<template>
    <div id="mapid"></div>
</template>

<script>

    import $ from "jquery";
    import "leaflet";
    import "leaflet-fullscreen";

    export default {
        name: "Map",
        props: [
            "initialLon",
            "initialLat",
            "initialZoom",
            "countryBorder"
        ],
        data() {
            return {
                map: null,
            }
        },
        methods: {
            renderMap() {

                this.map = L.map('mapid', {
                    fullscreenControl: true,
                }).setView([this.initialLon, this.initialLat], this.initialZoom || 6);

                L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4NXVycTA2emYycXBndHRqcmZ3N3gifQ.rJcFIG214AriISLbB6B5aw', {
                    maxZoom: 18,
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, ' +
                        '<a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                        'Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    id: 'mapbox/streets-v11',
                    tileSize: 512,
                    zoomOffset: -1,
                }).addTo(this.map);

                this.map.addLayer(L.marker([this.initialLon, this.initialLat]));

                $('#mapid').css("height", "350px");
            },
        },
        async mounted() {
            // https://github.com/vue-leaflet/Vue2Leaflet/issues/103
            delete L.Icon.Default.prototype._getIconUrl
            L.Icon.Default.mergeOptions({
                iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
                iconUrl: require('leaflet/dist/images/marker-icon.png'),
                shadowUrl: require('leaflet/dist/images/marker-shadow.png')
            })

            this.renderMap();
        }
    }
</script>

<style lang="less" scoped>

    @import "../../node_modules/leaflet/dist/leaflet.css";
    @import "../../node_modules/leaflet-fullscreen/dist/leaflet.fullscreen.css";


</style>